import styled from 'styled-components';

export const StyledLabel = styled.label<{ isPunchup?: boolean }>`
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	font-family: ${({ theme }) => theme.fonts.primary};
	font-size: 16px;
	line-height: 20px;
	margin-bottom: 8px;
`;
